/**
 * @module FAQs
 * @description
 */
import { useEffect } from "react";
import { useInView } from "react-intersection-observer";
import { v4 as uuidv4 } from "uuid";
import FAQItem from "./AccordionItem";
import styles from "./index.module.css";
import buildFAQSchema from "@/js/utils/schema";
import { trackEvent } from "@/js/helpers/tracking";

const position = "FAQs";

/**
 * @function Component
 * @description
 */
const Component = ({ ...props }) => {
  const {
    headline = "FAQs",
    subhead = "Questions about Frontier? We’ve got answers.",
    accordionData = [
      {
        title:
          "Is Frontier Fiber Internet service available in my neighborhood?",
        content:
          "Frontier Fiber is available in many neighborhoods across 17 states and adding more every day.",
      },
      {
        title: "How fast are Frontier Fiber Internet Speeds?",
        content:
          "On our 100% fiber-optic network to the home, max wired download/upload speeds can range as fast as 5000/5000 Mbps where available.",
      },
      {
        title: "What is Frontier Fiber Internet?",
        content:
          "Frontier Fiber Internet uses a collection of ultra-thin fiber-optic wires encased in a cable to deliver your connection.",
      },
      {
        title: "Which Frontier Internet plan is best for me?",
        content:
          "The internet plan you choose should depend on a few factors. The number of devices and users in your home, what those users do on the web and even your home’s floor plan correlate with the speed you need. If you live in a home with many connected devices and users or a home with lots of walls, consider a faster speed so everyone can do what they love with ease. If you need help deciding, give our fiber internet experts a call and they’ll help you determine the plan right for you",
      },
    ],
  } = props;

  const FAQschema = buildFAQSchema(accordionData);

  const options = {
    threshold: 1,
    triggerOnce: true,
  };
  const { ref, entry } = useInView(options);

  useEffect(() => {
    if (entry?.isIntersecting === true) {
      const data = {
        elementType: "SECTION",
        text: `${position} - HEADLINE VIEWED`,
      };
      trackEvent({ action: "elementViewed", data, event: {} });
    }
  }, [entry]);

  return (
    <>
      <section className="component">
        <div className={styles.component__layout}>
          <h2 ref={ref} className={styles.headline}>
            {headline}
          </h2>
          <h3 className={`h4 ${styles.subhead}`}>{subhead}</h3>

          {accordionData.map(({ title, content }, index) => (
            <FAQItem key={uuidv4()} id={index} title={title}>
              {content}
            </FAQItem>
          ))}
        </div>
      </section>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: `${FAQschema}`,
        }}
      />
    </>
  );
};

export default Component;
